export default __webpack_public_path__ + "static/media/home_icon.78c6e013.svg";